<template>
  <ModuleContainer v-bind="bindModule">
    <template #draggable>
      <DraggablePopup
        :show.sync="c_show"
        :title="title"
        :top="100"
        :width="600"
        :right="10"
        :height="500"
        :is-resizable="false"
      >
        <template #extra-btn>
          <!-- <v-icon
            v-if="mode === 'features'"
            @click="mode = 'properties'"
            title="Danh sách thuộc tính"
          >
            mdi-alert-circle
          </v-icon>
          <v-icon v-else title="Danh sách đối tượng" @click="mode = 'features'">
            mdi-table
          </v-icon> -->
        </template>

        <v-data-table
          v-show="mode === 'properties'"
          class="full-height full-width"
          :headers="fields.headers"
          :loading="fields.loading"
          :items="fields.items"
          disable-filtering
          fixed-header
          disable-pagination
          hide-default-footer
          height="100%"
        >
          <template v-slot:[`item.type`]="{ item }">
            <span v-if="item.type">
              {{ $t(`property.type.${item.type}`) }}
            </span>
          </template>
        </v-data-table>

        <div v-show="mode === 'features'" class="full-width full-height">
          <div class="d-flex flex-column full-width full-height">
            <div class="flex-grow-1">
              <div class="full-width full-height">
                <ag-grid-vue
                  style="width: 100%; height: 100%"
                  class="ag-theme-alpine"
                  rowModelType="infinite"
                  @grid-ready="onGridReady"
                  rowSelection="single"
                  :defaultColDef="defaultColDef"
                  :sideBar="sideBar"
                  :columnDefs="columnDefs"
                >
                </ag-grid-vue>
              </div>
            </div>
            <div class="flex-grow-0 pa-2">
              <base-pagination
                :page.sync="p_pagination.page"
                :perpage.sync="p_pagination.itemsPerPage"
                :total="p_pagination.total"
                @update="updatePagination()"
                hidePerPage
              ></base-pagination>
            </div>
          </div>
        </div>
      </DraggablePopup>
    </template>
    <slot />
  </ModuleContainer>
</template>

<script>
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'

import { AgGridVue } from 'ag-grid-vue'

import { DraggablePopup } from '@components/draggable'
import ModuleMixin from '@components/Map/mixins/ModuleMixin'

import LayerTableAction from './LayerTableAction.vue'
import { getLayerData } from './model/layer'
import { PhanTichLayerDataSource } from './PhanTichLayerDataSource'

export default {
  components: { DraggablePopup, AgGridVue },
  props: { layer: { require: true }, show: { type: Boolean } },
  mixins: [ModuleMixin],
  data: (vm) => ({
    mode: 'features',
    fields: {
      loading: false,
      items: [],
      headers: [
        {
          text: 'Tên trường',
          value: 'name',
        },
        { text: 'Kiểu', value: 'type' },
      ],
    },
    columnDefs: [],
    defaultColDef: {
      flex: 1,
      resizable: true,
    },
    p_pagination: {
      page: 1,
      itemsPerPage: 100,
      total: 0,
    },
    sideBar: {
      toolPanels: [
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
        },
      ],
    },
  }),
  computed: {
    title() {
      if (!this.layer) return ''
      return `${this.layer.name}`
    },
    c_layer: {
      get() {
        return this.layer
      },
      set(value) {
        this.$emit('update:layer', value)
      },
    },
    c_show: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      },
    },
  },
  methods: {
    async onSetLayer(layer) {
      this.fields.items = layer.metadata.fields
      this.fields.items.sort((a, b) => a.order - b.order)
      this.setHeaders()
      this.setData()
    },
    onDestroy() {
      this.onSetHightlight()
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.onSetLayer(this.layer)
    },
    setData() {
      if (!this.layer) return
      let successCallback = (res) => {
        this.p_pagination.total = res.pagination.total
      }
      let dataSources = new PhanTichLayerDataSource(
        this.layer.info,
        {
          successCallback,
        },
        this.p_pagination
      )

      this.gridApi.setDatasource(dataSources)
    },
    onShowDetail(item) {
      this.$root.$emit('layer-control:show-detail', {
        data: item,
        fields: this.fields.items,
      })
    },
    onSetHightlight(feature) {
      if (!feature) {
        this.$root.$emit('layer-control:hightlight-layer', {
          type: 'FeatureCollection',
          features: [],
        })
        return
      }
      let field_geometry = this.layer.field_geometry || 'geometry'
      let geometry = feature[field_geometry]
      this.$root.$emit('layer-control:hightlight-layer', {
        type: 'FeatureCollection',
        features: [{ type: 'Feature', geometry, properties: {} }],
      })
    },
    setHeaders() {
      let vm = this
      this.columnDefs = getAgGridTableHeadersFromProperties(
        this.fields.items
      ).concat({
        cellRendererFramework: LayerTableAction,
        width: 100,
        pinned: 'right',
        headerName: 'Thao tác',
        cellRendererParams: {
          layer: vm.layer,
          action: {
            fitBounds: (e) => vm.fitBounds(e),
            showDetail: (e) => vm.onShowDetail(e),
            hightlight: (e) => vm.onSetHightlight(e),
          },
        },
      })
    },
    updatePagination() {
      this.setData()
    },
  },
}
function getAgGridTableHeadersFromProperties(properties) {
  return properties
    .filter(
      (p) =>
        (!p.visibility || p.visibility.browse) &&
        !['geometry', 'photo', 'video', 'region-field'].includes(p.type)
    )
    .reduce((acc, p) => {
      const header = {
        headerName: p.name,
        field: `${p.code}`,
        minWidth: 200,
      }
      acc.push(header)

      return acc
    }, [])
}
</script>
